import showAlert from '../alert/alertHandler';
const responseCodeManager = (error) => {
  switch (error.response.status) {
    case 400:
      //ERROR 400 - BAD REQUEST
      showAlert(
        '¡Lo sentimos!',
        'El contenido del formulario es inválido.  [BAD REQUEST - ' + error.response.status + ']',
        'error',
        null,
        error.response.data.parameterViolations,
      );
      break;
    case 401:
      //ERROR 401 - UNAUTHORIZED
      showAlert(
        '¡Lo sentimos!',
        'La acción realizada no fué autorizada.  [UNAUTHORIZED - ' + error.response.status + ']',
        'error',
      );
      break;
    case 403:
      //ERROR 403 - FORBIDDEN
      showAlert(
        '¡Lo sentimos!',
        'No tienes permisos para acceder a este recurso.  [FORBIDDEN - ' + error.response.status + ']',
        'error',
      );
      break;
    case 404:
      //ERROR 404 - NOT FOUND
      showAlert(
        '¡Lo sentimos!',
        'El recurso solicitado no fue encontrado.  [NOT FOUND - ' + error.response.status + ']',
        'error',
      );
      break;
    case 500:
      //ERROR 500 - INTERNAL SERVER ERROR
      showAlert(
        '¡Lo sentimos!',
        'Un error interno a ocurrido en el servidor.  [INTERNAL SERVER ERROR - ' + error.response.status + ']',
        'error',
        null,
        error.request.response,
      );
      break;
    case 502:
      //ERROR 502 - BAD GATEWAY
      showAlert(
        '¡Lo sentimos!',
        'Problema de comunicación entre los servidores.  [BAD GATEWAY - ' + error.response.status + ']',
        'error',
      );
      break;
    case 503:
      //ERROR 503 - SERVICE UNAVAILABLE
      showAlert(
        '¡Lo sentimos!',
        'Algo inesperado ha ocurrido en lado del servidor.  [SERVICE UNAVAILABLE - ' + error.response.status + ']',
        'error',
      );
      break;
    default:
      showAlert('¡Lo sentimos!', 'Un error desconocido ha ocurrido.  [UNKOWN - ???]', 'error');
      break;
  }
};

export default responseCodeManager;
